import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardContainer } from "../widgets";
import LoadHistoryContent from "./LoadHistoryContent";
import { leftSideToggle } from "../../actions/user";
import "../../../assets/scss/load-history.scss";
import { LoadHistoryProvider } from "./context/LoadHistoryContext";
import OffCanvas from "../layout/offcanvas/OffCanvas";

const LoadHistoryPage = (props) => {
	const aiChatStatus = useSelector((state) => state.load.isAiChatBot);
	const showChatRoom = useSelector((state) => state.load.isShowChatBotRoom);

	const dispatch = useDispatch();
	const { farmId, crewId, egId, isTruck, title } = props.match.params;

	useEffect(() => {
		dispatch(leftSideToggle());
	}, []);

	useEffect(() => {
		return () => {
			dispatch(leftSideToggle());
		};
	}, []);

	// useEffect(() => {
	//     if (farmId) {
	//         const url = (egId) ? `/home/farm/${farmId}/map/eg/${egId}`
	//             : (crewId ? `/home/farm/${farmId}/map/crew/${crewId}` : `/home/farm/${farmId}/map`);
	//         setReturnUrl(url);
	//     }

	//     return () => {
	//         props.actions.loadHistory();
	//     };
	// }, [farmId]);

	// const getBackButton = () => <NavLink to={returnUrl}>
	//     <Button variant="danger" size="sm" className="float-right mr-2">
	//         <i className="fa fa-arrow-left"></i> Back
	//     </Button>
	// </NavLink>;

	return (
		<div className="load-history">
			<CardContainer className="px-3" lg={12} md={12} sm={12} xs={12}>
				<div
					className={`load-history-chat-bot-container ${aiChatStatus && showChatRoom === 1 ? "chat-bot-active" : ""
						}`}
				>
					<LoadHistoryProvider>
						<LoadHistoryContent
							farmId={farmId}
							crewId={crewId}
							egId={egId}
							title={title}
							isTruck={isTruck === "true"}
						// backButton={getBackButton()}
						/>
					</LoadHistoryProvider>
					{aiChatStatus && showChatRoom === 1 && (
						<OffCanvas isVertexAi={false} />
					)}
				</div>
			</CardContainer>
		</div>
	);
};
export default LoadHistoryPage;